import React from 'react'
import {motion} from 'framer-motion'
import {images} from '../../constants'
import {AppWrap} from '../../wrapper'

import './Header.scss'
import {TypeAnimation} from "react-type-animation";

const Header = () => {

    return (
        <div className='app__header app__flex'>
            <div className='app__header-info'>
                <div className='app__header-badge'>
                    <div className='badge-cmp app__flex'>
                        <div style={{marginLeft: 20}}>
                            <TypeAnimation
                                sequence={[
                                    'Hello !'
                                ]}
                                speed={30}
                                className='head-text'
                                cursor={false}
                            />

                            <img src={images.smiley} alt="smiley"/>
                        </div>
                    </div>
                    <div className='tag-cmp'>
                        <p className='p-text'>moi c'est</p>
                        <p className='p-text'>Anne Lise</p>
                    </div>
                    <div className='tag-cmp app__flex'>
                        <TypeAnimation
                            sequence={[
                                'Community Manager'
                            ]}
                            speed={15}
                            className='head-text'
                        /></div>
                </div>
            </div>

            <motion.div
                whileInView={{opacity: [0, 1]}}
                transition={{duration: 0.5, delayChildren: 0.5}}
                className='app__header-img'
            >
                <img src={images.profile1} alt='profile-bg'/>
            </motion.div>
        </div>
    )
}

export default AppWrap(Header,
    'accueil',
    'app__primarybg'
)

